import React, { useEffect } from 'react'
import '../../message/Message.css'
import ChatInput from './ChatInput'
import MessageContainer from './MessageContainer'
import classes from './styles.module.scss'

const Chat = ({
  postMessage,
  messages,
  startData,
  parentURL,
  device,
  connected,
  isTextDisabled,
  settings,
  setIframe,
  iframeSettings,
  isMobile,
  chatId,
  botId,
  isEmpowerPre,
  isEmpowerPost,
  isPanoramaPost,
  showLoader,
  getMoreChatHistory,
  isMaximized,
  autofilledText,
  isUserIdle,
  isScrollChat,
  setAnchorMenu,
  showTyping,
  firstUnreadMessageId,
  avatarLogo,
  setIsIframeContentLoaded,
  setIsImageZoomed,
  initializeConversation,
  setIsLoadingIframeData,
  isLoadingIframeData,
  imageModalSettings,
  setImageModalSettings,
  datePickerSettings,
  setDatePickerSettings,
  updateMessagesState,
  passedOrSkippedFlowComponentsId,
  startTiming,
  widgetLoadedStartTiming,
  isDDRumTimingSent,
  setIsDDRumTimingSent,
  setPassedOrSkippedFlowComponentsId,
  textMessageRef,
  persistentMenuButtonRef,
  widgetIframeSource,
  setWidgetIframeSource,
  language
}) => {

  useEffect(() => {
    initializeConversation()
  }, [])

  const isRtl = messages && messages.length && messages[messages.length - 1].isRtl

  return (
    <>
      <main className={classes.wrap}>
        <MessageContainer
          chatId={chatId}
          device={device}
          parentURL={parentURL}
          isUserIdle={isUserIdle}
          messages={messages}
          settings={settings}
          isEmpowerPre={isEmpowerPre}
          isEmpowerPost={isEmpowerPost}
          isPanoramaPost={isPanoramaPost}
          imageModalSettings={imageModalSettings}
          setImageModalSettings={setImageModalSettings}
          datePickerSettings={datePickerSettings}
          setDatePickerSettings={setDatePickerSettings}
          setIframe={setIframe}
          iframeSettings={iframeSettings}
          connected={connected}
          isMobile={isMobile}
          id="message-container"
          showTyping={showTyping}
          postMessage={postMessage}
          isTextDisabled={isTextDisabled}
          showLoader={showLoader}
          getMoreChatHistory={getMoreChatHistory}
          isMaximized={isMaximized}
          isScrollChat={isScrollChat}
          setAnchorMenu={setAnchorMenu}
          firstUnreadMessageId={firstUnreadMessageId}
          avatarLogo={avatarLogo}
          isRtl={isRtl}
          setIsIframeContentLoaded={setIsIframeContentLoaded}
          setIsImageZoomed={setIsImageZoomed}
          setIsLoadingIframeData={setIsLoadingIframeData}
          isLoadingIframeData={isLoadingIframeData}
          updateMessagesState={updateMessagesState}
          passedOrSkippedFlowComponentsId={passedOrSkippedFlowComponentsId}
          setPassedOrSkippedFlowComponentsId={setPassedOrSkippedFlowComponentsId}
          textMessageRef={textMessageRef}
          startTiming={startTiming}
          widgetLoadedStartTiming={widgetLoadedStartTiming}
          isDDRumTimingSent={isDDRumTimingSent}
          setIsDDRumTimingSent={setIsDDRumTimingSent}
          persistentMenuButtonRef={persistentMenuButtonRef}
          widgetIframeSource={widgetIframeSource}
          setWidgetIframeSource={setWidgetIframeSource}
          language={language}
        />
      </main>
      <ChatInput
        startData={startData}
        settings={settings}
        postMessage={postMessage}
        isTextDisabled={isTextDisabled}
        chatId={chatId}
        botId={botId}
        isRtl={isRtl}
        device={device}
        autofilledText={autofilledText}
      />
    </>
  )
}

export default Chat
